// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonIcon_container__8cx75","disabled":"ButtonIcon_disabled__1huVK"};